import { SURVEY_QUESTION_CHROME } from "../constants/constantsSurveys";

export const cardContainerSx = {
  width: "100%",
  maxWidth: {
    xs: "100%",
    sm: "100%",
    md: "632px"
  },
  border: `1px solid ${SURVEY_QUESTION_CHROME.plainBorder}`,
  borderRadius: "10px",
  backgroundColor: "#FFFFFF",
  overflow: "hidden"
};

export const headerSx = (collapsed) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: {
    xs: "wrap",
    sm: "nowrap"
  },
  minHeight: {
    xs: 48,
    sm: 60
  },
  height: "auto",
  padding: {
    xs: "6px 8px",
    sm: "8px 16px 8px 8px"
  },
  rowGap: {
    xs: 0.5,
    sm: 0
  },
  borderBottom: collapsed ? "none" : "1px solid #D9D9D9",
  backgroundColor: SURVEY_QUESTION_CHROME.plainBackground
});

export const dragHandleSx = {
  display: "flex",
  alignItems: "center",
  mr: 1.5,
  ml: -0.5,
  cursor: "grab",
  color: "#9CA3AF"
};

export const dragIconSx = {
  fontSize: {
    xs: 16,
    sm: 20
  }
};

export const questionTextSx = {
  fontSize: {
    xs: 12,
    sm: 16
  },
  fontWeight: SURVEY_QUESTION_CHROME.titleFontWeight,
  color: SURVEY_QUESTION_CHROME.titleColor,
  mr: {
    xs: 0.5,
    sm: 1.5
  },
  whiteSpace: {
    xs: "normal",
    sm: "nowrap"
  },
  lineHeight: 1.2
};

export const chipSx = {
  height: {
    xs: 20,
    sm: 25
  },
  maxWidth: {
    xs: 110,
    sm: 180
  },
  fontSize: {
    xs: 9,
    sm: 12
  },
  borderRadius: "18px",
  backgroundColor: SURVEY_QUESTION_CHROME.chipBackground,
  color: SURVEY_QUESTION_CHROME.chipText,
  "& .MuiChip-label": {
    px: {
      xs: 1,
      sm: 2
    },
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }
};

export const collapseButtonSx = {
  mr: 1,
  p: 0.5,
  color: "#757575"
};

export const collapseIconSx = (collapsed) => ({
  fontSize: {
    xs: 22,
    sm: 30
  },
  transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
  transition: "transform 0.2s ease"
});

export const actionsButtonSx = {
  p: 0.5,
  mr: {
    xs: 0.5,
    sm: 0
  },
  color: "#757575"
};

export const actionsIconSx = {
  fontSize: {
    xs: 20,
    sm: 28
  }
};

export const bodySx = (collapsed) => ({
  px: {
    xs: 1.5,
    sm: 2.5
  },
  pt: 2,
  pb: collapsed ? 3 : 2.5,
  display: "flex",
  flexDirection: "column",
  gap: {
    xs: 1.2,
    sm: 2
  }
});

export const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    backgroundColor: "#FFFFFF",
    fontSize: {
      xs: 13,
      sm: 15
    },
    color: "#2F2F2F"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#C9C9C9"
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#BDBDBD"
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#BDBDBD"
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#9E9E9E",
    opacity: 1
  }
};

export const previewAnswerSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#F5F5F5",
    borderRadius: "6px",
    cursor: "default",

    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9"
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9"
    }
  },

  "& textarea": {
    pointerEvents: "none",
    cursor: "default",
    color: "#9E9E9E",
    WebkitTextFillColor: "#9E9E9E"
  },

  "& input": {
    pointerEvents: "none",
    cursor: "default",
    color: "#9E9E9E",
    WebkitTextFillColor: "#9E9E9E"
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#C9C9C9"
  },

  "& .MuiInputBase-input::placeholder": {
    color: "#9E9E9E",
    opacity: 1
  }
};

export const dividerSx = {
  borderColor: "#D9D9D9"
};

export const footerSx = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  px: {
    xs: 1.5,
    sm: 3
  },
  mb: 1.5
};

export const footerInnerSx = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  rowGap: 0.5
};

export const checkboxSx = {
  p: 0,
  color: "#757575",
  "& .MuiSvgIcon-root": {
    fontSize: {
      xs: 18,
      sm: 22
    }
  }
};

export const footerTextSx = {
  fontSize: {
    xs: 12,
    sm: 15
  },
  lineHeight: 1.3
};

export const menuPaperSx = {
  borderRadius: "10px",
  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
  minWidth: {
    xs: 140,
    sm: 180
  }
};